// components/common/SubscriptionStatus/index.jsx
import React from 'react';  // Remove useEffect
import { useSelector } from 'react-redux';  // Remove useDispatch
import { useNavigate } from 'react-router-dom';
import { 
    selectUserSubscription, 
    selectPendingRequest 
} from '../../../store/slices/subscriptionSlice';
import { SUBSCRIPTION_STATES, SUBSCRIPTION_STATUS_LABELS } from '../../../config/constants';
import {
    StatusContainer,
    StatusHeader,
    StatusContent,
    ActionButton,
    StatusBadge
} from './styles';

const SubscriptionStatus = ({ children }) => {
    const navigate = useNavigate();
    const subscription = useSelector(selectUserSubscription);
    const pendingRequest = useSelector(selectPendingRequest);

    // Remove useEffect and fetchSubscriptionStatus call since Dashboard will handle it

    const renderContent = () => {
        // If there's a pending request
        if (pendingRequest) {
            switch (pendingRequest.status) {
                case SUBSCRIPTION_STATES.PENDING_ADMIN:
                    return (
                        <StatusContainer>
                            <StatusHeader warning>
                                <StatusBadge status={pendingRequest.status}>
                                    {SUBSCRIPTION_STATUS_LABELS[pendingRequest.status]}
                                </StatusBadge>
                            </StatusHeader>
                            <StatusContent>
                                <p>Your subscription request is being reviewed by our team.</p>
                                <p className="info">We'll notify you once it's approved.</p>
                            </StatusContent>
                        </StatusContainer>
                    );

                case SUBSCRIPTION_STATES.PENDING_PAYMENT:
                    return (
                        <StatusContainer>
                            <StatusHeader alert>
                                <StatusBadge status={pendingRequest.status}>
                                    {SUBSCRIPTION_STATUS_LABELS[pendingRequest.status]}
                                </StatusBadge>
                            </StatusHeader>
                            <StatusContent>
                                <p>Your subscription request has been approved!</p>
                                <p className="info">Please complete the payment to activate your subscription.</p>
                                <ActionButton onClick={() => navigate('/payment')}>
                                    Complete Payment
                                </ActionButton>
                            </StatusContent>
                        </StatusContainer>
                    );

                case SUBSCRIPTION_STATES.PAYMENT_SUBMITTED:
                    return (
                        <StatusContainer>
                            <StatusHeader warning>
                                <StatusBadge status={pendingRequest.status}>
                                    {SUBSCRIPTION_STATUS_LABELS[pendingRequest.status]}
                                </StatusBadge>
                            </StatusHeader>
                            <StatusContent>
                                <p>Your payment is being verified.</p>
                                <p className="info">We'll activate your subscription once verified.</p>
                            </StatusContent>
                        </StatusContainer>
                    );

                default:
                    return null;
            }
        }

        // If there's an active subscription
        if (subscription?.status === SUBSCRIPTION_STATES.ACTIVE) {
            return children;
        }

        // No subscription or pending request
        return (
            <StatusContainer>
                <StatusHeader>
                    <h3>No Active Subscription</h3>
                </StatusHeader>
                <StatusContent>
                    <p>Subscribe to start booking photography sessions.</p>
                    <ActionButton onClick={() => navigate('/pricing')}>
                        View Plans
                    </ActionButton>
                </StatusContent>
            </StatusContainer>
        );
    };

    return renderContent();
};

export default SubscriptionStatus;